import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useI18n } from "../i18n";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const Header = () => {
  const { lang, setLang, t } = useI18n();
  const [open, setOpen] = useState(false);

  const navItems = [
    { to: "/fleet", label: t.nav.fleet, id: "fleet" },
    { to: "/about", label: t.nav.about, id: "about" },
    { to: "/contact", label: t.nav.contact, id: "contact" },
  ];

  return (
    <header
      className="sticky top-0 z-50 backdrop-blur-xl bg-[#050505]/75 border-b border-white/10"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center" data-testid="logo-home-link">
          <Logo size="md" />
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {navItems.map((item) => (
            <NavLink
              key={item.id}
              to={item.to}
              data-testid={`nav-${item.id}`}
              className={({ isActive }) =>
                `text-sm font-mono-ui uppercase tracking-[0.18em] transition-colors ${
                  isActive ? "text-white" : "text-zinc-400 hover:text-white"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-6">
          <div
            className="hidden md:flex items-center gap-1 font-mono-ui text-xs tracking-widest"
            data-testid="language-toggle"
          >
            <button
              onClick={() => setLang("en")}
              className={`px-2 py-1 transition-colors ${
                lang === "en"
                  ? "text-white border-b border-[#FFB400]"
                  : "text-zinc-500 hover:text-white"
              }`}
              data-testid="lang-en-btn"
            >
              EN
            </button>
            <span className="text-zinc-700">/</span>
            <button
              onClick={() => setLang("pt")}
              className={`px-2 py-1 transition-colors ${
                lang === "pt"
                  ? "text-white border-b border-[#FFB400]"
                  : "text-zinc-500 hover:text-white"
              }`}
              data-testid="lang-pt-btn"
            >
              PT
            </button>
          </div>

          <Link
            to="/fleet"
            className="hidden md:inline-flex btn-primary text-sm py-3 px-5"
            data-testid="header-book-cta"
          >
            {t.nav.book}
          </Link>

          <button
            className="md:hidden text-white"
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            aria-label="menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-[#050505]" data-testid="mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-4">
            {navItems.map((item) => (
              <Link
                key={item.id}
                to={item.to}
                onClick={() => setOpen(false)}
                className="text-white font-heading text-xl"
                data-testid={`mobile-nav-${item.id}`}
              >
                {item.label}
              </Link>
            ))}
            <div className="flex items-center gap-3 pt-4">
              <button
                onClick={() => setLang("en")}
                className={`text-xs font-mono-ui px-3 py-2 border ${
                  lang === "en"
                    ? "border-[#FFB400] text-white"
                    : "border-white/10 text-zinc-400"
                }`}
                data-testid="mobile-lang-en"
              >
                EN
              </button>
              <button
                onClick={() => setLang("pt")}
                className={`text-xs font-mono-ui px-3 py-2 border ${
                  lang === "pt"
                    ? "border-[#FFB400] text-white"
                    : "border-white/10 text-zinc-400"
                }`}
                data-testid="mobile-lang-pt"
              >
                PT
              </button>
            </div>
            <Link
              to="/fleet"
              className="btn-primary mt-4 justify-center"
              onClick={() => setOpen(false)}
              data-testid="mobile-book-cta"
            >
              {t.nav.book}
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
